import React, { useCallback, useMemo } from "react";
import { connect } from "react-redux";
import { TabPanel, Item as TabItem } from "devextreme-react/tab-panel";
import FormField from "../../dynamicFormBuilder/FormField";
import { UserDefinedCodesLayout, UserDefinedReferencesLayout } from "./Layout";

// User Defined tab for the IM Transaction Entry form (Delphi uIMD0019 "&User").
//
// Delphi nests two pages inside it (pagBottomUserDefined): "Codes" holds USERDEFINEDCODE_1..10 with
// USERDEFINEDDATE_1..10 and USERDEFINEDQUANTITY_1..10, and "References" holds
// USERDEFINEDREFERENCE_1..10 with USERDEFINEDCOMMENT. Each page gets its own FormField and its own
// layoutId, so a user's saved layout for one does not overwrite the other.
//
// Both bind the same shared formFields as the other tabs, so the fields still round-trip via Form.js.
function UserDefinedTab(props) {
    const currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const codesLayout = useMemo(() => UserDefinedCodesLayout, []);
    const referencesLayout = useMemo(() => UserDefinedReferencesLayout, []);

    const handleSelectionChange = useCallback((name, value, e) => {
        props.handleFieldChange(name, value, e);
    }, [props.handleFieldChange]);

    // No coded dropdowns on this tab; onFormLoad is a required no-op for the dynamic builder.
    const handleFormLoad = useCallback(() => {}, []);

    return (
        <div>
            <TabPanel showNavButtons={true} deferRendering={false}>
                <TabItem title="Codes">
                    <FormField
                        currrentUser={currentUser}
                        layoutId="0019d019-4c67-4e89-d3fa-0019ddeeff03"
                        layoutName="IMTransactionEntryUserDefinedCodesForm"
                        defaultFormSchema={codesLayout}
                        formFields={props.formFields}
                        setformFields={props.setformFields}
                        handleFieldValueChange={handleSelectionChange}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={props.formRefs}
                        onFormLoad={handleFormLoad}
                    />
                </TabItem>
                <TabItem title="References">
                    <FormField
                        currrentUser={currentUser}
                        layoutId="0019d019-4c67-4e89-d3fa-0019ddeeff04"
                        layoutName="IMTransactionEntryUserDefinedReferencesForm"
                        defaultFormSchema={referencesLayout}
                        formFields={props.formFields}
                        setformFields={props.setformFields}
                        handleFieldValueChange={handleSelectionChange}
                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                        formRefs={props.formRefs}
                        onFormLoad={handleFormLoad}
                    />
                </TabItem>
            </TabPanel>
        </div>
    );
}

function mapStateToProps(state) {
    return { oidc: state.oidc };
}

export default connect(mapStateToProps)(UserDefinedTab);
